// import React from "react";
import { UserButton, UserSkeleton } from "@/features/user-button";
import { formatRelativeTime } from "@/lib/date-tools";
import { Button } from "@/components/ui/button";
// import { showMessageBox } from "@/components/blocks/message-box";
import { X } from "lucide-react";
import { useTranslation } from "@/providers/language-provider";
// import { signal } from "@preact/signals-react";
import { useSignals } from "@preact/signals-react/runtime";
// import { graphQLClient } from "@/lib/client-graphql";
import {
  sentRequests,
  cancelFriendRequest,
  isFetching,
} from "@/pages/subs/friends/friend-manager";

export const SentRequests = () => {
  useSignals();
  const { t } = useTranslation();

  return (
    <>
      {isFetching.value ? (
        <div className="space-y-2 p-2">
          <UserSkeleton />
          <UserSkeleton />
        </div>
      ) : (
        sentRequests.value?.map((req: any) => (
          <UserButton
            key={req._id}
            asButton={false}
            user={req.recipient}
            variant="ghost"
          >
            <div className="flex items-center space-x-2">
              <span>{formatRelativeTime(req.createdAt)}</span>
              <Button
                size="sm"
                variant="destructive"
                onClick={() => cancelFriendRequest.value?.(req)}
              >
                <X className="h-4 w-4 mr-1" />
                {t("Cancel")}
              </Button>
            </div>
          </UserButton>
        ))
      )}
    </>
  );
};
